import React, { useState, useRef, useEffect, useContext } from "react";
import {
  MapContainer as Map,
  TileLayer,
  Marker,
  Popup,
  useMapEvents,
} from "react-leaflet";
import L from "leaflet";
import "../styles/addPost.css";
import { mapConfig } from "../helper/mapConfig";
import { useNavigate } from "react-router";
import {
  filterPosts,
  getCategoriesByType,
  listPosts,
  profileUser,
} from "../api/service";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { getPost } from "../api/service";
import { useParams, useLocation } from "react-router-dom";
import Axios from "axios";
import { countItems } from "../utils/searchParams.utils";
import useSearchParamsCustom from "../hooks/useSearchParamsCustom";
import CategoryDropdown from "../components/Category";
import Popover from "../components/Popover";
import Filter from "../components/Filter";

const markerIcon = new L.Icon({
  iconUrl: require("../assets/markerIcon.png"),
  iconSize: [40, 45],
  iconAnchor: [17, 46],
  popupAnchor: [0, -46],
});

const DPIcon = new L.Icon({
  iconUrl: require("../assets/DPin.png"),
  iconSize: [50, 55],
  iconAnchor: [17, 46],
  popupAnchor: [0, -46],
});

const FIcon = new L.Icon({
  iconUrl: require("../assets/FPin.png"),
  iconSize: [50, 55],
  iconAnchor: [17, 46],
  popupAnchor: [0, -46],
});
const IWIcon = new L.Icon({
  iconUrl: require("../assets/IWPin.png"),
  iconSize: [50, 55],
  iconAnchor: [17, 46],
  popupAnchor: [0, -46],
});
const PDIcon = new L.Icon({
  iconUrl: require("../assets/PDPin.png"),
  iconSize: [50, 55],
  iconAnchor: [17, 46],
  popupAnchor: [0, -46],
});
const GDIcon = new L.Icon({
  iconUrl: require("../assets/GDPin.png"),
  iconSize: [50, 55],
  iconAnchor: [17, 46],
  popupAnchor: [0, -46],
});
const AGIcon = new L.Icon({
  iconUrl: require("../assets/AGPin.png"),
  iconSize: [50, 55],
  iconAnchor: [17, 46],
  popupAnchor: [0, -46],
});
const WLIcon = new L.Icon({
  iconUrl: require("../assets/WLPin.png"),
  iconSize: [50, 55],
  iconAnchor: [17, 46],
  popupAnchor: [0, -46],
});

const Maps = () => {
  let token = localStorage.getItem("token");
  const navigate = useNavigate();
  const profileInit = () => {
    profileUser(token).then((req, res) => {
      console.log(req.data);
      if (req.data.status !== "failed") {
        console.log(req.data);
      } else {
        navigate("/");
      }
    });
  };

  const [posts, setPosts] = useState([]);
  const [postTypes, setPostTypes] = useState();
  const [cities, setCities] = useState();
  const [states, setStates] = useState();
  const [countries, setCountries] = useState();

  const { setSearchParamsCustom, getSearchParam, deleteSearchParam } =
    useSearchParamsCustom();

  const handleCategorySelect = (category, categoryName) => {
    const categories = getSearchParam(categoryName)?.split(",") || [];
    if (getSearchParam(categoryName)?.includes(category)) {
      if (countItems(getSearchParam(categoryName) || "") === 1) {
        deleteSearchParam(categoryName);
        return;
      }

      categories.splice(categories.indexOf(category), 1);
      setSearchParamsCustom(categoryName, categories.join(","));
    } else {
      categories.push(category);
      if (categories.length === 1) {
        setSearchParamsCustom(categoryName, category);
        return;
      }
      setSearchParamsCustom(categoryName, categories.join(","));
    }
  };

  const applyFilters = async () => {
    try {
      const postTypes = getSearchParam("postType") || [];
      const cities = getSearchParam("city") || [];
      const states = getSearchParam("state") || [];
      const countries = getSearchParam("country") || [];

      const filterParams = {
        postTypes,
        cities,
        states,
        countries,
      };

      const filteredProperties = await filterPosts(filterParams);
      console.log(filteredProperties);
      setPosts(filteredProperties);
      return filteredProperties;
    } catch (error) {
      console.error(error);
    }
  };

  const fetchCategories = async (categoryType) => {
    try {
      const posts = await getCategoriesByType(categoryType);
      const categoriesSet = new Set();
      if (categoryType === "postType") {
        posts.forEach((post) => categoriesSet.add(post.category));
        setPostTypes(Array.from(categoriesSet));
      } else if (categoryType === "city") {
        posts.forEach((post) => categoriesSet.add(post.city));
        setCities(Array.from(categoriesSet));
      } else if (categoryType === "state") {
        posts.forEach((post) => categoriesSet.add(post.state));
        setStates(Array.from(categoriesSet));
      } else if (categoryType === "country") {
        posts.forEach((post) => categoriesSet.add(post.country));
        setCountries(Array.from(categoriesSet));
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      return [];
    }
  };

  const fetchUnfilteredPosts = async () => {
    listPosts(token)
      .then((res) => {
        setPosts(res.data);
      })
      .catch((err) => console.log(err));
  };

  const removeFilters = () => {
    deleteSearchParam("postType");
    deleteSearchParam("city");
    deleteSearchParam("state");
    deleteSearchParam("country");
    fetchUnfilteredPosts();
  };

  useEffect(() => {
    profileInit();
    fetchCategories("postType");
    fetchCategories("city");
    fetchCategories("state");
    fetchCategories("country");
    fetchUnfilteredPosts();
  }, []);

  const [center, setCenter] = useState({
    lat: 21.567545592626146,
    lng: 79.11035209894182,
  });
  const ZOOM_LEVEL = 4;
  const mapRef = useRef(null);
  useEffect(() => {
    profileInit();
  }, []);

  return (
    <>
      <Navbar />
      <div className="md:h-full h-screen pt-24 dark:bg-[#010409] bg-[#FAF7F0]">
      <div className="heading absolute top-0 w-screen px-4 py-2 bg-gray-300  ">
          <h2 className="text-3xl font-bold text-gray-800 dark:text-white">Maps</h2>
        </div>
        <div className="w-full text-center">
          <Filter postTypes={postTypes} cities={cities} states={states} countries={countries} handleCategorySelect={handleCategorySelect} applyFilters={applyFilters} removeFilters={removeFilters} countItems={countItems} getSearchParam={getSearchParam}/>
          <div className="flex flex-col items-center">
          
            <Map
              center={center}
              zoom={ZOOM_LEVEL}
              ref={mapRef}
              className="w-[90%] rounded-lg shadow-2xl shadow-gray-500 z-0"
            >
              <TileLayer
                url={mapConfig.maptiler.url}
                attribution={mapConfig.maptiler.attribution}
              />
              {posts &&
                posts.map((post, idx) => (
                  <Marker
                    position={[post.lat, post.lng]}
                    icon={
                      post.category === "Waterlogging"
                        ? WLIcon
                        : post.category === "Algae growth"
                        ? AGIcon
                        : post.category === "Pipeline damage"
                        ? PDIcon
                        : post.category === "Industrial waste"
                        ? IWIcon
                        : post.category === "Garbage Disposal"
                        ? GDIcon
                        : post.category === "Flash Flood"
                        ? FIcon
                        : markerIcon
                    }
                    key={idx}
                  >
                    <Popup>
                      <div className="p-2">
                        <img
                          src={post.image}
                          alt={post.title}
                          className="popup-image w-35 h-35 object-fit rounded-lg mb-4"
                        />
                        <div className="">
                          <h3 className="text-xl font-bold text-gray-700">
                            {post.title} <br />
                            <span className="text-gray-400 text-xs font-semibold">
                              {post.city}, {post.state}
                            </span>
                          </h3>

                          <p className="text-[#1f7e30] text-sm font-semibold">
                            {post.category}
                          </p>
                          <button
                            className="shadow-none w-full text-white bg-[#1f7e30] font-bold hover:bg-[#2ea043] rounded-md py-2 mt-2"
                            onClick={() => navigate("/posts/" + post._id)}
                          >
                            Explore
                          </button>
                        </div>
                      </div>
                    </Popup>
                  </Marker>
                ))}
            </Map>
            {/* <button onClick={() => console.log(position)}>Position</button> */}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Maps;
